import createDuck from '../../../lib/ducks/remoteDuck'
import CategoryApiHandler from '../../../lib/api/category'

export default createDuck({
  namespace: 'content',
  store: 'category',
  fetchCallback: CategoryApiHandler.get,
})
